import { Key } from "../../Data/HexMap/Key"
import { Coordinates } from "../../Util/Math/Coordinates"

export class KeyCtrlMenuState{
    setter:Function
    key:Key|null
    coordinates:Coordinates
    setMap:Function
    isOpen:boolean
    constructor(setter:Function){
      this.isOpen = false
      this.setter = setter
      this.key = null
      this.coordinates = new Coordinates(200,200)
      this.setMap = ()=>{}
    }
    setIsOpen = (b:boolean) => {
      const openSetter = (state:KeyCtrlMenuState)=>{
        return({ isOpen:b})
      }
      this.setter(openSetter)
    }
    setKey = (key:Key) => {
      const keySetter = (state:KeyCtrlMenuState)=>{
        return({ key: Key })
      }
      this.setter(keySetter)
    }
    setCoordinates = (coords:Coordinates) => {
      const coordsSetter = (state:KeyCtrlMenuState)=>{
        return({ coordinates: coords })
      }
      this.setter(coordsSetter)     
    }
    setKeyConfig = (key:Key, coords:Coordinates, setMap:Function) => {
      console.log('setKeyConfig')
     const configSetter = (state:KeyCtrlMenuState)=>{
        return({ isOpen:true, coordinates: coords, key:key, setMap:setMap })
      }
      this.setter(configSetter)
    }
    setState = (obj:any) => {
      this.setter((state:KeyCtrlMenuState) => (obj))
    }
  }